module.exports = __webpack_public_path__ + "img/GENERAL-IGNIS-2.f333e4ce.jpg";